export default {
    QM_QUALIFICATION_FAILED: 'QM_QUALIFICATION_FAILED',
};
